<template>
	<div class="e-learning-container">
		<router-link to="/" exact class="btn-back">
			<img src="images/chevron-left-green.svg" class="mr-1" />powrót
		</router-link>
		<div class="e-learning-header">
			<h2>klient doświadczony</h2>
			<learning-progress-circle
				:movies="allLessons"
				:finishedLessons="doneLessons"
			/>
		</div>
		<div class="d-flex justify-content-between flex-wrap">
			<learning-box
				v-for="(course, i) in getCourses"
				:key="i"
				:id="course.id"
				:name="course.name"
				:movies="course.movies"
				:finishedLessons="finished(course.movies)"
				:lessonsTime="learningTime(course.movies)"
				:icon="course.iconCss"
			/>
			<learning-box
				v-if="getCourses"
				:key="'Test wiedzy'"
				:id="0"
				:name="'Test wiedzy'"
				:icon="testIcon()"
				:isTestReady="isTestReady()"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import LearningProgressCircle from './partial/LearningProgressCircle';
import LearningBox from './partial/LearningBox';
import { eLearningMethods, eLearningLessons } from '@/mixins/e-learning.js';
export default {
	data() {
		return {
			accepted: false,
		};
	},
	mixins: [eLearningMethods, eLearningLessons],
	methods: {
		disabledBox(index) {
			if (index === this.courses.courses.length - 1) {
				return this.courses.done
					? 'e-learning-box-success'
					: 'e-learning-box-disabled';
			}
		},
		isTestReady() {
			let isAllFinished = [];
			Array.prototype.forEach.call(this.getCourses, (course) => {
				for (var i = 0; i < course.movies.length; i++) {
					isAllFinished.push(course.movies[i].done);
				}
			});
			return isAllFinished.find((item) => item === false) === false
				? 'e-learning-box-disabled'
				: 'e-learning-box-success';
		},
		testIcon() {
			let icon = this.isTestReady();
			return icon === 'e-learning-box-disabled' ? 'lock.svg' : 'test.svg';
		},

		// TYLKO DO TESTÓW LOKALNIE
		// isYouTubeExist() {
		// 	var url = 'https://www.youtube.com/iframe_api';
		// 	var scripts = document.getElementsByTagName('script');
		// 	for (var i = scripts.length; i--; ) {
		// 		if (scripts[i].src == url) return true;
		// 	}
		// 	return false;
		// },
	},
	components: {
		LearningProgressCircle,
		LearningBox,
	},
	computed: {
		...mapGetters(['getCourses']),
		doneLessons() {
			let done = [];
			Array.prototype.forEach.call(this.getCourses, (course) => {
				for (var i = 0; i < course.movies.length; i++) {
					if (course.movies[i].done) {
						done.push(course.movies[i].done);
					}
				}
			});
			return done.length;
		},
		allLessons() {
			let all = 0;
			Array.prototype.forEach.call(this.getCourses, (course) => {
				all += course.movies.length;
			});
			return all;
		},
	},
	beforeMount() {
		this.$store.commit('setChangePath', false);
		this.$store.commit('setCookieYTModal', false);
		this.$store.dispatch('fetchCourses');
		if (this.$cookies.get('learningInformation')) {
			this.accepted = true;
		} else {
			this.$store.commit('setLearningModal', true);
		}
	},
	// TYLKO DO TESTÓW LOKALNIE
	// mounted() {
	// 	if (!this.isYouTubeExist()) {
	// 		var first = document.getElementsByTagName('script')[0];
	// 		var tag = document.createElement('script');
	// 		tag.src = 'https://www.youtube.com/iframe_api';
	// 		tag.className = 'yt-frame-api';
	// 		first.parentNode.insertBefore(tag, first);
	// 	}
	// },
};
</script>
